// 월 단리 적금
export function simpleInterest(price, rate, months) {
    rate /= 100 * 12;
    return Math.floor(
        ((price * (1 + rate) + price * (1 + rate * months)) * months) / 2
    );
}

// 월 복리 적금
export function compoundInterest(price, rate, months) {
    rate /= 100 * 12;
    return Math.floor((price * (1 + rate) * ((1 + rate) ** months - 1)) / rate);
}

function getDateDiff(first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((first - second) / (1000 * 60 * 60 * 24));
}

function getDueDate(startDate, period) {
    const dueDate = new Date(startDate);
    dueDate.setMonth(dueDate.getMonth() + period);
    return dueDate;
}

function findOptimizedDate(dateItems) {
    let optimizedDate;
    let minDiff = -99999;
    for (const item of dateItems) {
        if (item[1] == 0) {
            return item;
        } else if (item[1] < 0) {
            if (Math.max(minDiff, item[1]) == item[1]) {
                optimizedDate = item;
            }
        }
    }
    return optimizedDate;
}

function createISOStringDate(date) {
    return date.toISOString().split("T")[0];
}

// 1-11, 1-23...
function depositAllLater(period, startDate) {
    let isDone = false;
    const payDate = new Date(startDate);
    const dateItems = [];

    while (!isDone) {
        let totalDateDiff = 0;
        payDate.setDate(payDate.getDate() + 1);
        for (let i = 1; i < period; i++) {
            const expectedDate = new Date(startDate);
            expectedDate.setMonth(expectedDate.getMonth() + i);
            totalDateDiff += getDateDiff(payDate, expectedDate);
        }

        const targetDiff = totalDateDiff / period;
        if (targetDiff > -1 && targetDiff < 1) {
            dateItems.push([createISOStringDate(payDate), totalDateDiff]);
        } else if (targetDiff >= 1) {
            isDone = true;
        }
    }

    return {
        firstPayDate: createISOStringDate(new Date(startDate)),
        optimizedDate: findOptimizedDate(dateItems),
        dateItems,
    };
}

// 1-6-5, 1-12-11...
function depositHalfLater(period, startDate, strategies) {
    const dateItems = [];
    const dayAfterStartDate = new Date(startDate);
    const dayBeforeDueDate = getDueDate(startDate, period);
    dayBeforeDueDate.setDate(dayBeforeDueDate.getDate() - 1);
    let dateDiffLastHalf = 0;
    let isDone = false;

    for (let i = 0; i < strategies.slice(-1)[0]; i++) {
        const expectedDate = new Date(startDate);
        expectedDate.setMonth(
            expectedDate.getMonth() + (strategies[0] + strategies[1] + i)
        );
        dateDiffLastHalf += getDateDiff(dayBeforeDueDate, expectedDate);
    }
    // 총 이연일 수=각 회차별 이연일의 합
    // 만기 이연일 수=총 이연일 수/총 납입 회차(period) -> 0이 되어야 하는 것
    while (!isDone) {
        let dateDiffFirstHalf = 0;
        dayAfterStartDate.setDate(dayAfterStartDate.getDate() + 1);
        for (let i = 1; i <= strategies[1]; i++) {
            const expectedDate = new Date(startDate);
            expectedDate.setMonth(expectedDate.getMonth() + i);
            dateDiffFirstHalf += getDateDiff(dayAfterStartDate, expectedDate);
        }
        const targetDiff = (dateDiffFirstHalf + dateDiffLastHalf) / period;
        if (targetDiff > -1 && targetDiff < 1) {
            dateItems.push([
                createISOStringDate(dayAfterStartDate),
                dateDiffFirstHalf + dateDiffLastHalf,
            ]);
        } else if (targetDiff >= 1) {
            isDone = true;
        }
    }
    return {
        firstPayDate: createISOStringDate(new Date(startDate)),
        optimizedDate: findOptimizedDate(dateItems),
        lastPayDate: createISOStringDate(dayBeforeDueDate),
        dateItems,
    };
}

// 6-1-5, 12-1-11...
function depositHalfFirst(period, startDate, strategies) {
    const firstDepositDate = new Date(startDate);
    const dayBeforeDueDate = getDueDate(startDate, period); // 마지막 납입일
    dayBeforeDueDate.setDate(dayBeforeDueDate.getDate() - 1);
    let dateDiffFirstHalf = 0;
    let dateDiffLastHalf = 0;
    let dateDiffMid = 0;
    let isDone = false;
    let dateItems = [];

    for (let i = 1; i <= period; i++) {
        const expectedDate = new Date(startDate);
        expectedDate.setMonth(expectedDate.getMonth() + (i - 1));
        if (i <= strategies[0]) {
            dateDiffFirstHalf += getDateDiff(firstDepositDate, expectedDate);
        } else if (i > strategies[0] + strategies[1]) {
            dateDiffLastHalf += getDateDiff(dayBeforeDueDate, expectedDate);
        }
    }

    const midDate = new Date(startDate);
    midDate.setMonth(midDate.getMonth() + strategies[0]);
    while (!isDone) {
        firstDepositDate.setDate(firstDepositDate.getDate() + 1);
        dateDiffMid = getDateDiff(firstDepositDate, midDate);
        const targetDiff =
            (dateDiffFirstHalf + dateDiffMid + dateDiffLastHalf) / period;

        if (targetDiff > -1 && targetDiff < 1) {
            dateItems.push([
                createISOStringDate(firstDepositDate),
                dateDiffFirstHalf + dateDiffMid + dateDiffLastHalf,
            ]);
        } else if (targetDiff >= 1) {
            isDone = true;
        }
    }
    return {
        firstPayDate: createISOStringDate(new Date(startDate)),
        optimizedDate: findOptimizedDate(dateItems),
        lastPayDate: createISOStringDate(dayBeforeDueDate),
        dateItems,
    };
}

function depositHalfAndTwice(period, startDate, strategies) {
    const firstDepositDate = new Date(startDate);
    const nextPayDate = new Date(startDate);
    nextPayDate.setDate(nextPayDate.getDate() + strategies[0]);
    const dayBeforeDueDate = getDueDate(startDate, period); // 마지막 납입일
    dayBeforeDueDate.setDate(dayBeforeDueDate.getDate() - 1);
    let dateDiffFirstHalf = 0;
    let isDone = false;
    let dateItems = [];

    for (let i = 1; i <= strategies[0]; i++) {
        const expectedDate = new Date(startDate);
        expectedDate.setMonth(expectedDate.getMonth() + (i - 1));
        dateDiffFirstHalf += getDateDiff(firstDepositDate, expectedDate);
    }

    while (!isDone) {
        let dateDiffLastHalf = 0;
        nextPayDate.setDate(nextPayDate.getDate() + 1);
        for (let i = strategies[0]; i < period; i++) {
            const expectedDate = new Date(startDate);
            expectedDate.setMonth(expectedDate.getMonth() + i);
            dateDiffLastHalf += getDateDiff(nextPayDate, expectedDate);
        }

        const targetDiff = (dateDiffFirstHalf + dateDiffLastHalf) / period;
        if (targetDiff > -1 && targetDiff < 1) {
            dateItems.push([
                createISOStringDate(nextPayDate),
                dateDiffFirstHalf + dateDiffLastHalf,
            ]);
        } else if (targetDiff >= 1) {
            isDone = true;
        }
    }

    return {
        firstPayDate: createISOStringDate(new Date(startDate)),
        optimizedDate: findOptimizedDate(dateItems),
        dateItems,
    };
}

function depositFourTimes(period, startDate, strategies) {
    const dateItems = [];
    const secondPayDate = new Date(startDate);
    secondPayDate.setMonth(secondPayDate.getMonth() + strategies[0]);
    const dayAfterSecondPayDate = new Date(startDate);
    dayAfterSecondPayDate.setMonth(
        dayAfterSecondPayDate.getMonth() + strategies[0]
    );
    const dayBeforeDueDate = getDueDate(startDate, period);
    dayBeforeDueDate.setDate(dayBeforeDueDate.getDate() - 1);
    let dateDiffLastHalf = 0;
    let isDone = false;

    for (let i = 0; i < strategies.slice(-1)[0]; i++) {
        const expectedDate = new Date(startDate);
        expectedDate.setMonth(
            expectedDate.getMonth() + (strategies[0] + strategies[1] + i)
        );
        dateDiffLastHalf += getDateDiff(dayBeforeDueDate, expectedDate);
    }
    // 총 이연일 수=각 회차별 이연일의 합
    // 만기 이연일 수=총 이연일 수/총 납입 회차(period) -> 0이 되어야 하는 것
    while (!isDone) {
        let dateDiffFirstHalf = 0;
        dayAfterSecondPayDate.setDate(dayAfterSecondPayDate.getDate() + 1);
        for (let i = 1; i <= strategies[1]; i++) {
            const expectedDate = new Date(startDate);
            expectedDate.setMonth(expectedDate.getMonth() + i);
            dateDiffFirstHalf += getDateDiff(
                dayAfterSecondPayDate,
                expectedDate
            );
        }
        const targetDiff = (dateDiffFirstHalf + dateDiffLastHalf) / period;
        if (targetDiff > -1 && targetDiff < 1) {
            dateItems.push([
                createISOStringDate(dayAfterSecondPayDate),
                dateDiffFirstHalf + dateDiffLastHalf,
            ]);
        } else if (targetDiff >= 1) {
            isDone = true;
        }
    }
    console.log(dateItems);
    return {
        firstPayDate: createISOStringDate(new Date(startDate)),
        secondPayDate: createISOStringDate(secondPayDate),
        optimizedDate: findOptimizedDate(dateItems),
        lastPayDate: createISOStringDate(dayBeforeDueDate),
        dateItems,
    };
}

export function calculateSuni(period, startDate, strategies) {
    if (strategies[0] === 1 && strategies.length === 3) {
        return depositHalfLater(period, startDate, strategies);
    } else if (strategies.length === 4) {
        return depositFourTimes(period, startDate, strategies);
    } else if (strategies[0] === 1) {
        return depositAllLater(period, startDate);
    } else if (strategies.length === 2) {
        return depositHalfAndTwice(period, startDate, strategies);
    } else {
        return depositHalfFirst(period, startDate, strategies);
    }
}

// function calculateSuniWithDepositDate(period, startDate, depositDate, strategies) {
//     const strategy = strategies[0] === 1 ? strategies[1] : strategies[0];
//     let dueDate = new Date(startDate);
//     dueDate = new Date(new Date(dueDate).setMonth(dueDate.getMonth() + period));
//     let dateDiff = 0;
//     let result = [];

//     for (let i = 1; i <= period; i++) {
//         const expectedDate = new Date(startDate);
//         expectedDate.setMonth(expectedDate.getMonth() + (i - 1));

//         if (i <= strategy) {
//             const planDate1 = i > 1 ? new Date(depositDate) : new Date(startDate);
//             let prePostDates1 = 0;
//             prePostDates1 = getDateDiff(planDate1, expectedDate);
//             dateDiff += prePostDates1;
//             result.push([expectedDate.toISOString(), planDate1.toISOString(), prePostDates1]);
//         } else if (i > strategy + 1) {
//             let planDate2 = new Date(dueDate);
//             planDate2 = new Date(new Date(planDate2).setDate(planDate2.getDate() - 1));
//             let prePostDates2 = 0;
//             prePostDates2 = getDateDiff(planDate2, expectedDate);
//             dateDiff += prePostDates2;
//             result.push([expectedDate.toISOString(), planDate2.toISOString(), prePostDates2]);
//         }
//     }

//     let targetExpectedDate = new Date(startDate);
//     targetExpectedDate = new Date(new Date(targetExpectedDate).setMonth(targetExpectedDate.getMonth() + strategy));
//     if (startDate === depositDate) {
//         let planDate3 = new Date(targetExpectedDate);
//         planDate3 = new Date(new Date(planDate3).setDate(planDate3.getDate() - dateDiff));
//         result.splice(strategy, 0, [targetExpectedDate.toISOString(), planDate3.toISOString(), -1 * dateDiff]);
//     } else {
//         result.splice(strategy, 0, [
//             targetExpectedDate.toISOString(),
//             new Date(depositDate).toISOString(),
//             -1 * getDateDiff(targetExpectedDate, new Date(depositDate)),
//         ]);
//     }

//     return result;
// }

// const period = 36;
// const startDate = "2022-06-08";
// const strategies = [1, 35];
// console.log(calculateSuni(period, startDate, strategies));
